export const ONBOARDING_STEP_KEY = {
  SOURCE_CODE_CONNECTION: 'SOURCE_CODE_CONNECTION',
  CONFIGURING_TARGET: 'CONFIGURING_TARGET',
  DISCOVERING_ASSETS: 'DISCOVERING_ASSETS',
  GENERATING_SIGNALS: 'GENERATING_SIGNALS',
  VALIDATING_SIGNALS: 'VALIDATING_SIGNALS',
  CREATING_FINDINGS: 'CREATING_FINDINGS',
} as const;

export type OnboardingStepKeyConstant =
  (typeof ONBOARDING_STEP_KEY)[keyof typeof ONBOARDING_STEP_KEY];

export const ONBOARDING_STEP_KEY_VALUES = [
  ONBOARDING_STEP_KEY.SOURCE_CODE_CONNECTION,
  ONBOARDING_STEP_KEY.CONFIGURING_TARGET,
  ONBOARDING_STEP_KEY.DISCOVERING_ASSETS,
  ONBOARDING_STEP_KEY.GENERATING_SIGNALS,
  ONBOARDING_STEP_KEY.VALIDATING_SIGNALS,
  ONBOARDING_STEP_KEY.CREATING_FINDINGS,
] as const;

export const DISCOVERING_SUB_STEP_KEYS = {
  VERIFYING_CREDENTIALS: 'VERIFYING_CREDENTIALS',
  CRAWLING: 'CRAWLING',
  FEATURE_ANALYSIS: 'FEATURE_ANALYSIS',
  DYNAMIC_SCANNING: 'DYNAMIC_SCANNING',
  READING_API_SPECS: 'READING_API_SPECS',
  DISCOVERING_ENDPOINTS_FROM_CODE: 'DISCOVERING_ENDPOINTS_FROM_CODE',
  VERIFYING_DISCOVERED_ENDPOINTS: 'VERIFYING_DISCOVERED_ENDPOINTS',
} as const;

export const DISCOVERING_ASSETS_SUB_STEP_KEY_VALUES = Object.values(
  DISCOVERING_SUB_STEP_KEYS,
);

export const GENERATING_SIGNALS_SUB_STEP_KEYS = {
  GENERATING_ENDPOINT_SIGNALS: 'GENERATING_ENDPOINT_SIGNALS',
  DEEP_CODE_ANALYSIS: 'DEEP_CODE_ANALYSIS',
} as const;

export const GENERATING_SIGNALS_SUB_STEP_KEY_VALUES = Object.values(
  GENERATING_SIGNALS_SUB_STEP_KEYS,
);

export const ONBOARDING_STEP_TRANSITION = {
  started: 'started',
  completed: 'completed',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export type OnboardingStepTransitionConstant =
  (typeof ONBOARDING_STEP_TRANSITION)[keyof typeof ONBOARDING_STEP_TRANSITION];

export const ONBOARDING_STEP_TRANSITION_VALUES = [
  ONBOARDING_STEP_TRANSITION.started,
  ONBOARDING_STEP_TRANSITION.completed,
  ONBOARDING_STEP_TRANSITION.failed,
  ONBOARDING_STEP_TRANSITION.skipped,
] as const;

export const ONBOARDING_STEP_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
} as const;

export type OnboardingStepStatusConstant =
  (typeof ONBOARDING_STEP_STATUS)[keyof typeof ONBOARDING_STEP_STATUS];

export const ONBOARDING_STEP_STATUS_VALUES = [
  ONBOARDING_STEP_STATUS.PENDING,
  ONBOARDING_STEP_STATUS.RUNNING,
  ONBOARDING_STEP_STATUS.COMPLETED,
  ONBOARDING_STEP_STATUS.FAILED,
  ONBOARDING_STEP_STATUS.SKIPPED,
] as const;

export const ONBOARDING_TERMINAL_STEP_STATUS_VALUES = [
  ONBOARDING_STEP_STATUS.COMPLETED,
  ONBOARDING_STEP_STATUS.FAILED,
  ONBOARDING_STEP_STATUS.SKIPPED,
] as const;

export type OnboardingTerminalStepStatusConstant =
  (typeof ONBOARDING_TERMINAL_STEP_STATUS_VALUES)[number];

export const isTerminalOnboardingStepStatus = (
  status: OnboardingStepStatusConstant | string,
): boolean =>
  (ONBOARDING_TERMINAL_STEP_STATUS_VALUES as readonly string[]).includes(
    status,
  );
